var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"leaflet-card",attrs:{"rounded":"","to":{
    name: 'Leaflet',
    params: { leafletId: _vm.leaflet.leafletId }
  }}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":_vm.small ? 12 : 6}},[_c('v-img',{attrs:{"alt":_vm.cover.alt,"eager":"","contain":"","src":_vm.cover.url}})],1),_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":_vm.small ? 12 : 6}},[_c('v-card-title',[_vm._v(_vm._s(_vm.leaflet.title))]),_c('v-spacer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }